/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_NameInputs */

const vi_grower_area_public_name = /** @type {(inputs: Grower_Area_Public_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên vùng trồng`)
};

/**

* @param {Grower_Area_Public_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_name = /** @type {((inputs?: Grower_Area_Public_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_name(inputs)
});